import {
  Avatar,
  Button,
  Dropdown,
  Form,
  Pagination,
  PaginationProps,
  Table,
  TableColumnsType,
} from "antd";
import {
  InputField,
  InputNumberField,
  InputPassword,
  InputPhone,
  InputTextArea,
  SelectField,
  TextEditor,
} from "../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { SearchIcon } from "../../atoms/CustomIcons";
import { useState } from "react";
import { TableRowSelection } from "antd/es/table/interface";
import { getInitials } from "../../config/utils";
import { MoreOutlined } from "@ant-design/icons";

interface FormValues {
  input: string;
  textarea: string;
  password: string;
  select: string;
  phone: string;
  number: number;
  textEditor: string;
}

export default function UI() {
  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm<FormValues>();
  const onSubmit = (val: FormValues) => {
    console.log("val", val);
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  interface DataType {
    key: React.Key;
    fullName: { firstName: string; lastName: string; status?: string } | string;
    Position: string;
    language: string;
    Email: string;
    Phone: string;
    Rockstar: string;
    JoinedCompany: string;
    Birthdate: string;
    Status: string;
  }

  const items = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            console.log("Edit");
          }}
        >
          Edit
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="delete-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          Delete
        </Button>
      ),
    },
  ];

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const columns: TableColumnsType<DataType> = [
    {
      title: "Full name",
      dataIndex: "fullName",
      width: 268,
      fixed: "left",
      render: (text) => {
        const avatarColor = getRandomColor();
        return (
          <div className="text_with_avatar">
            <Avatar style={{ backgroundColor: avatarColor }}>
              {getInitials(text?.firstName, text?.lastName)}
            </Avatar>
            <div className="text_wrap">
              {text?.firstName} {text?.lastName}{" "}
              {text?.status && (
                <span style={{ color: "#98A3A9" }}>({text?.status})</span>
              )}
            </div>
          </div>
        );
      },
    },
    {
      title: "Position",
      dataIndex: "Position",
      width: 196,
    },
    {
      title: "First language",
      dataIndex: "language",
      width: 195,
    },
    {
      title: "Email",
      dataIndex: "Email",
      width: 239,
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      width: 196,
    },
    {
      title: "Rockstar at",
      dataIndex: "rockstar_at_text",
      width: 229,
    },
    {
      title: "Joined company",
      dataIndex: "JoinedCompany",
      width: 196,
    },
    {
      title: "Birthdate",
      dataIndex: "Birthdate",
      width: 196,
    },
    {
      title: "Status",
      dataIndex: "Status",
      width: 160,
    },
    {
      title: "Status",
      dataIndex: "Status",
      width: 160,
    },
    {
      title: "",
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: () => (
        <Dropdown
          menu={{ items }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{ padding: "6px", height: "auto" }}
            className="only_icon"
            icon={<MoreOutlined />}
          />
        </Dropdown>
      ),
    },
  ];

  const data: DataType[] = [
    {
      key: "1",
      fullName: {
        firstName: "Esther De Las",
        lastName: "Howard",
        status: "invited",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "2",
      fullName: {
        firstName: "Jason",
        lastName: "Teptimus",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "3",
      fullName: {
        firstName: "Marcus",
        lastName: "George",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "4",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "5",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "6",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "7",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "8",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "9",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "10",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
    {
      key: "11",
      fullName: {
        firstName: "Maren",
        lastName: "Stanton",
      },
      Position: "Production manager",
      language: "English",
      Email: "robert-br@gmail.com",
      Phone: "+1 (912) 123-5689",
      Rockstar: "Pruning",
      JoinedCompany: "Aug 12, 2023",
      Birthdate: "Jun 20",
      Status: "Active",
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const itemRender: PaginationProps["itemRender"] = (
    _,
    type
    // originalElement
  ) => {
    if (type === "prev") {
      return "Previous";
    }
    if (type === "next") {
      return "Next";
    }
    // return null;
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const handlePageChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <div className="ui_component" style={{ width: "1400px", padding: "40px" }}>
      <br />
      <br />
      <div className="table_with_filter">
        <div>
          <Pagination
            itemRender={itemRender}
            total={data?.length}
            showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
            onChange={handlePageChange}
            current={currentPage}
            pageSize={pageSize}
          />
        </div>
        <Table<DataType>
          rowSelection={{ type: "checkbox", ...rowSelection }}
          columns={columns}
          dataSource={data}
          scroll={{ x: "max-content" }}
          // pagination={false}
          pagination={
            data?.length < 11
              ? false
              : {
                  position: ["topRight"],
                  // simple: { readOnly: true },
                  itemRender: itemRender,
                  total: data?.length,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total}`,
                }
          }
        />
      </div>
      <Form
        layout="vertical"
        onFinish={handleSubmit(onSubmit)}
        autoComplete="off"
        name="dependencies"
        style={{ display: "none" }}
      >
        <InputField
          fieldName="input"
          label="Label"
          control={control}
          iProps={{
            placeholder: "Placeholder",
          }}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.input && "error"}
          validMessage={errors.input && errors.input.message}
          prefix={<SearchIcon />}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />
        <InputTextArea
          fieldName="textarea"
          label="Label"
          control={control}
          iProps={{
            placeholder: "Placeholder",
          }}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.textarea && "error"}
          validMessage={errors.textarea && errors.textarea.message}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />

        <InputPassword
          fieldName="password"
          label="Label"
          control={control}
          iProps={{
            placeholder: "Placeholder",
          }}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.password && "error"}
          validMessage={errors.password && errors.password.message}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />
        <SelectField
          fieldName="select"
          label="Label"
          control={control}
          iProps={{
            placeholder: "Placeholder",
          }}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.select && "error"}
          validMessage={errors.select && errors.select.message}
          prefix={<SearchIcon />}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
          onSelectChange={(label, value) => console.log(label, value)}
          selectOption={[
            { value: "jack", label: "Jack abc" },
            { value: "lucy", label: "Lucy def" },
            { value: "Yiminghe", label: "yiminghe ghi" },
            { value: "disabled", label: "Disabled jkl" },
          ]}
        />
        <InputPhone
          fieldName="phone"
          label="Label"
          control={control}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.phone && "error"}
          validMessage={errors.phone && errors.phone.message}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />
        <InputNumberField
          fieldName="number"
          label="Label"
          control={control}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.number && "error"}
          validMessage={errors.number && errors.number.message}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />
        <TextEditor
          fieldName="textEditor"
          label="Label"
          control={control}
          isRequired
          rules={{
            required: "First name is required.",
          }}
          validate={errors.textEditor && "error"}
          validMessage={errors.textEditor && errors.textEditor.message}
          tooltipTitle="Enter your first name"
          hintMessage="Caption"
        />

        <Button htmlType="submit" className="outlined-btn">
          Button
        </Button>
      </Form>
    </div>
  );
}
